import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import el from "./modules/el";
import et from "./modules/et";
import ihl from "./modules/ihl";
import kdhl from "./modules/kdhl";

Vue.use(Vuex);

import state from "./state";
import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    app,
    el,
    et,
    ihl,
    kdhl,
  },
});
